import logo from "@/assets/img/logo3.jpg";
import "./styles.css";
export const SpinLogo = () => {
  return <img src={logo} className="spin-logo" alt="Divina Ordem Mística" />;
};
